export const isNullOrWhiteSpace = (text: string | null | undefined): text is (null | undefined | "") => {
    if (typeof text === "undefined" || text == null) return true;

    return text.trim() === "";
};
